import { Injectable } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

//import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'primeng/tooltip';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
////import { AppRoutingModule } from './app-routing.module';
//import { SharedModule } from './shared/shared.module';
import { SharedService } from '../shared/shared.service';
import { Observable } from 'rxjs';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class InitialService {

  constructor(
    public sharedService: SharedService
  ) { }

  getPublicData() {
    return this.sharedService.getData('');
  }

  /**
   * To get roles list
   */
  getRoles(): Observable<any> {
    const getRolesUrl = '';
    return this.sharedService.getData(getRolesUrl);
  }

  /**
   * To get Total count
   */
  getCount(): Observable<any> {
    const getCountUrl = '';
    return this.sharedService.getData(getCountUrl);
  }

}
